export default "__VITE_ASSET__DMckOopc__"